import { ChangeDetectorRef, Directive, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, Type, ViewContainerRef } from '@angular/core';
import { Section } from '../../editor-container/editor-model';

@Directive({
  selector: '[dynamicSectionRenderer]'
})
export class DynamicSectionRendererDirective implements OnChanges {
  @Input() section:Section;
  sectionData:any;
  rendererType:string;
  title:string;
  sectionTemplate:Type<any>
  //@Output() rendererType:EventEmitter<string> = new EventEmitter<string>();
  //@Output() sectionData:EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public viewContainerRef: ViewContainerRef,
    private cdr: ChangeDetectorRef,) { }

  ngOnChanges(changes:SimpleChanges):void{
    if(changes["section"]){
      console.log(this.section)
      this.sectionTemplate = this.section.sectionTemplate;
      if(this.section.rendererType != undefined){
        this.rendererType = this.section.rendererType;
      }
      if(this.section.title != undefined){
        this.title = this.section.title.text;
      }
      if(this.section.sectionData != undefined){
        this.sectionData = this.section.sectionData;
      }
      this.cdr.detectChanges();
    }
  }

}
